module.exports = __webpack_public_path__ + "6858bb30aa06661a90f7130a804f187d.svg";